import React from "react";
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'; // Updated icon imports
import { IFAQItem } from "../constants/faqConstant";
import 'flowbite';

interface IProps {
  data: IFAQItem[];
}

export const FAQItem: React.FC<IProps> = (props: IProps) => {
  const { data } = props;

  return (
    <dl className="divide-y divide-gray-900/10">
      {data.map(({ id, title, content }) => (
        <Disclosure key={id} as="div" className="py-6 first:pt-0 last:pb-0">
          {({ open }) => (
            <>
              <dt>
                <DisclosureButton className="flex w-full items-start justify-between text-left text-gray-900 dark:text-white">
                  <span className="text-base/7 font-semibold">{title}</span>
                  <span className="ml-6 flex h-7 items-center">
                    {/* Plus icon visible when closed */}
                    {!open ? (
                      <PlusSmallIcon aria-hidden="true" className="h-5 w-5" />
                    ) : (
                      // Minus icon visible when open
                      <MinusSmallIcon aria-hidden="true" className="h-5 w-5" />
                    )}
                  </span>
                </DisclosureButton>
              </dt>
              <DisclosurePanel as="dd" className="mt-2 pr-12">
                <p className="text-base/7 text-gray-600 dark:text-gray-300">{content}</p>
              </DisclosurePanel>
            </>
          )}
        </Disclosure>
      ))}
    </dl>
  );
};
